import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/services/spinner.service';
import {documentoService} from 'src/app/services/documento.service'
import { setConfigTable, validarCodigoExistentesComercial, basicAlert, alertaConfirmacionHTML3, obtenerFechaSeleccionada, obtenerFechaActual, timerOut, filtrarCoincidenciaArrayTransportista, validarInputVacio, alertaConfirmacion, openDescripcion, openObservacion, alertaConfirmacionHTML } from 'src/app/shared/utils';

@Component({
  selector: 'app-md-actualizar-dam',
  templateUrl: './md-actualizar-dam.component.html',
  styleUrls: ['./md-actualizar-dam.component.css']
})
export class MdActualizarDamComponent implements OnInit {
  @Input() numint:any;
  constructor(
    private spinnerService: SpinnerService,
    private modalactiveService: NgbActiveModal,
    private toastr: ToastrService,
    private documentoService: documentoService,
  ) { }

  ngOnInit(): void {
  }
  @Input() valorDam;
  
  _ok(){
    this.spinnerService.activarLoading(true);
    this.documentoService.actualiza_dam(this.numint,this.valorDam).subscribe((response:any)=>{
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.toastr.success("Se modificó correctamente")
      this.modalactiveService.close();
    }, err=>{
      console.log(err);
      this.spinnerService.activarLoading(false);
      basicAlert('Servicio no disponible','warning','Aceptar',null,null,null);
    }
    
    )  
  }
  _close() {
    this.modalactiveService.dismiss('canceling');
  }
}
